import { Injectable } from '@angular/core';
import { LanguagesTransformersShared } from '../../shared/LanguagesApi.datatransform';

@Injectable({
    providedIn: 'root'
})
export class LanguagesTransformers extends LanguagesTransformersShared {}
